import { Volume } from '~/shared/types/api';
import { getVolumeStableRowId } from '~/shared/utils/volumeHelpers';

import RenderTagGroup from '../../common/RenderTagGroups';

interface VolumeTagsRendererProps {
  data: Volume | undefined;
  maxVisible?: number;
}

/**
 * Renders only volume tags with a "+N" indicator for overflow tags
 */
const VolumeTagsRenderer = ({ data, maxVisible = 2 }: VolumeTagsRendererProps) => {
  if (!data || !data.tags || data.tags.length === 0) {
    return <span className="text-xs text-gray-2"></span>;
  }

  return (
    <div className="flex flex-wrap items-center gap-1">
      <RenderTagGroup
        items={data.tags}
        getText={(tag) => {
          // Format tag as "key: value", handling empty values
          const name = tag.key || '';
          const value = tag.value || '';
          if (name && value) {
            return `${name}: ${value}`;
          }
          return name || value || `Tag`;
        }}
        getUniqueKey={(tag, index) => `tag-${tag.key}-${index}`}
        variant="volume"
        maxVisible={maxVisible}
        tooltipIdPrefix={`volumetags-${getVolumeStableRowId(data)}`}
        size="sm"
      />
    </div>
  );
};

export default VolumeTagsRenderer;
